import { createAction, props } from '@ngrx/store';
import { Forecast } from '../../models/forecast.model';

// Load Forecasts
export const loadForecasts = createAction(
  '[Forecasts] Load Forecasts',
  props<{ stockId?: string }>()
);

export const loadForecastsSuccess = createAction(
  '[Forecasts] Load Forecasts Success',
  props<{ forecasts: Forecast[] }>()
);

export const loadForecastsFailure = createAction(
  '[Forecasts] Load Forecasts Failure',
  props<{ error: string }>()
);

// Load Single Forecast
export const loadForecast = createAction('[Forecasts] Load Forecast', props<{ id: string }>());

export const loadForecastSuccess = createAction(
  '[Forecasts] Load Forecast Success',
  props<{ forecast: Forecast }>()
);

export const loadForecastFailure = createAction(
  '[Forecasts] Load Forecast Failure',
  props<{ error: string }>()
);

// Create Forecast
export const createForecast = createAction(
  '[Forecasts] Create Forecast',
  props<{ forecast: Forecast }>()
);

export const createForecastSuccess = createAction(
  '[Forecasts] Create Forecast Success',
  props<{ forecast: Forecast }>()
);

export const createForecastFailure = createAction(
  '[Forecasts] Create Forecast Failure',
  props<{ error: string }>()
);

// Update Forecast
export const updateForecast = createAction(
  '[Forecasts] Update Forecast',
  props<{ id: string; forecast: Forecast }>()
);

export const updateForecastSuccess = createAction(
  '[Forecasts] Update Forecast Success',
  props<{ forecast: Forecast }>()
);

export const updateForecastFailure = createAction(
  '[Forecasts] Update Forecast Failure',
  props<{ error: string }>()
);

// Delete Forecast
export const deleteForecast = createAction('[Forecasts] Delete Forecast', props<{ id: string }>());

export const deleteForecastSuccess = createAction(
  '[Forecasts] Delete Forecast Success',
  props<{ id: string }>()
);

export const deleteForecastFailure = createAction(
  '[Forecasts] Delete Forecast Failure',
  props<{ error: string }>()
);
